import importer from 'common/importer';
const { deloitReq: req } = importer('APIs', null);
const Config = importer('Config');

let CORE_SCHEDULER_BASIC_AUTH;
if (Config.PLATFORM_TYPE != 'mobile') {
	CORE_SCHEDULER_BASIC_AUTH = WEB_SCHEDULER_BASIC_AUTH;
}

/**
 * @param {String} userId Takeda User ID from OKTA /authn call
 */
const main = ({ userId }) => {
	const config = {
		headers: {
			Authorization: `Basic ${
				Config.SCHEDULER_BASIC_AUTH || CORE_SCHEDULER_BASIC_AUTH
			}`
		}
	};
	return req.get(`/auth/factors/${userId}`, config);
};

export default main;
